//#region redux
import { AppState } from "store";
import { useSelector } from "react-redux";
//#endregion
//#region types
import { AuthEnums } from "models/enums";
//#endregion
//#region components
import useCheckRelations from "components/common/useCheckRelations";
//#endregion

function useSelfInvoicePermissions() {
  const isSelfInvoicingEnabled = useSelector((store: AppState) => store.auth.selectedCompany.isSelfInvoicingEnabled);
  const { hasRelations } = useCheckRelations();

  const canCreateSelfInvoices = () => {
    return (
      isSelfInvoicingEnabled &&
      hasRelations([AuthEnums.PersonCompanyRelationType.Invoices, AuthEnums.PersonCompanyRelationType.InvoicesAdmin])
    );
  };

  return { isSelfInvoicingEnabled, canCreateSelfInvoices };
}

export default useSelfInvoicePermissions;
